import React, { FC } from 'react';

import { Banner } from '$uikit';
import { useTranslator } from '$hooks';
import router from '$navigation/router';
import { SUBSCRIPTION_AUTHOR } from '$shared/constants/pages';

export const FreeChatBanner: FC<{ peerId: number }> = ({ peerId }) => {
  const t = useTranslator();

  return (
    <div style={{ padding: 16 }}>
      <Banner
        onClick={() => router.navigate(SUBSCRIPTION_AUTHOR, { authorId: peerId })}
        title={t('free_chat_banner_title')}
        caption={t('free_chat_banner_text')}
        mode="white"
      />
    </div>
  );
};
